import FilterAPI from 'apis/FilterAPI';

/**
 * Load all excerpts for a project with pagination
 * @param {string} projectId - The project ID
 * @param {Object} filters - Filter parameters to apply
 * @returns {Promise<Array>} - Array of all excerpts
 */
export async function loadAllFilteredExcerpts(projectId, filters = {}) {
  const allExcerpts = [];
  let offset = 0;
  const limit = 100;
  let hasMore = true;
  
  // Extract filter parameters
  const codeIds = filters.codes || [];
  const choiceIds = filters.multi_choices || [];
  const transcriptIds = filters.transcripts || [];
  const surveyIds = filters.surveys || [];
  const op = filters.op || 'or';
  const sort = filters.sort || 'position';
  const source = filters.source || 'export';
  
  while (hasMore) {
    try {
      const response = await FilterAPI.filterByCodes(
        projectId,
        codeIds,
        choiceIds,
        transcriptIds,
        surveyIds,
        limit,
        offset,
        op,
        sort,
        source
      );
      
      const excerpts = response.data.excerpts || [];
      allExcerpts.push(...excerpts);
      
      // Check if there are more excerpts to load
      // Use the total count and current progress to determine if more pages exist
      const totalCount = response.data.count || 0;
      hasMore = allExcerpts.length < totalCount;
      offset += limit;
    } catch (error) {
      console.error(`Error loading excerpts at offset ${offset}:`, error);
      throw error;
    }
  }
  
  return allExcerpts;
}

/**
 * Load all excerpts without filters for Word export
 * @param {string} projectId - The project ID
 * @returns {Promise<Array>} - Array of all excerpts
 */
export async function loadAllExcerpts(projectId) {
  return loadAllFilteredExcerpts(projectId, {});
}